/**
 * `<PlaudSourcePanel>` — placeholder card for the v1.5 Plaud connector.
 *
 * v4 P8 refit (2026-05-18, GAP_ANALYSIS_R2.md §5 / SO5): keeps the
 * placeholder pattern (dashed border, dimmed) so the source set reads
 * complete + the v1.5 slot is visible. Makes no API calls.
 *
 * U7 refit (2026-07-05): adopted the canonical `<SettingsCard>` chrome (the
 * `.s-card` grammar) via the `.source-planned` wrapper for the dashed/dimmed
 * treatment. The disabled iOS-pill toggle was removed — a dead toggle on a
 * not-yet-shipped connector read as breakage; the "planned" badge carries
 * the message alone.
 */

import { SettingsCard } from '@/surfaces/settings/SettingsCard';

export function PlaudSourcePanel(): JSX.Element {
  return (
    <div className="source-planned">
      <SettingsCard
        id="plaud"
        title={
          <>
            Plaud
            <span className="chip" title="Scheduled for v1.5 per the product roadmap">
              v1.5 · planned
            </span>
          </>
        }
        desc="Plaud transcript ingestion ships in v1.5 (PRD §8.3). Until then transcripts arrive via Joplin sync. This slot is shown so the source set reads complete."
      >
        {null}
      </SettingsCard>
    </div>
  );
}
